import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DataPrivacyComponent} from '@modules/home/policies/pages/data-privacy/data-privacy.component';
import {ImpressumComponent} from '@modules/home/policies/pages/impressum/impressum.component';
import {AnbComponent} from '@modules/home/policies/pages/anb/anb.component';
import {AebComponent} from '@modules/home/policies/pages/aeb/aeb.component';
import {AbsichtserklaerungComponent} from '@modules/home/policies/pages/absichtserklaerung/absichtserklaerung.component';
import {HomeRoutes} from '@app/routes/home.routes';
import {OoeRaffleConditionsComponent} from '@modules/home/policies/pages/participation-conditions/ooe-raffle-2021-conditions/ooe-raffle-conditions.component';
import {DefaultRaffleConditionsComponent} from '@modules/home/policies/pages/participation-conditions/default-raffle-conditions/default-raffle-conditions.component';

const policies = HomeRoutes.policies;

export const routes: Routes = [
  { path: policies.data, component: DataPrivacyComponent},
  { path: policies.imprint, component: ImpressumComponent},
  { path: policies.termsOfUse, component: AnbComponent},
  { path: policies.termsOfPublication, component: AebComponent},
  { path: policies.intent, component: AbsichtserklaerungComponent},
  { path: policies.participation,
    children: [
      { path: '', redirectTo: 'gewinnspiele' },
      { path: 'gewinnspiele', component: DefaultRaffleConditionsComponent },
      { path: 'spiel-des-jahres', component: OoeRaffleConditionsComponent },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PoliciesRouting { }
